import LogoSvg from '../../assets/images/logo.svg'

type Props = {
    className?: string,
    style?: React.CSSProperties | undefined,
}

export const Logo = ({ className, style }: Props) => {
    return (
        <img className = { className }  style = { style } src = { LogoSvg } alt="Logo" />
    );
}